import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../product/style/productGraid.css';
import '../product/style/categoryList.css';
import '../product/style/GridModal.css';
import ModalBoxPopup from '../product/component/ModalBoxPopup';
import GridListingData from '../product/GridListingData';
import BreadcrumbSecand from '../../Component/breadcrumb/BreadcrumbSecand';
import { getcategory } from './service/category.service';

function ProductGraid() {
  const [show, setShow] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const location = useLocation();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  //  serach design shade 
  const [search, setSearch] = useState("");
  const filteredProducts = products.filter((item) => {
  const keyword = search.trim().toLowerCase();
  if (!keyword) return true;
  const design = item.design?.toLowerCase() || "";
  const shade = item.shade?.toLowerCase() || "";
  const designShade = `${design} ${shade}`;
  return (
    design.includes(keyword) ||
    shade.includes(keyword) ||
    designShade.includes(keyword)
  );
});

  //  serach design shade close  

  // FETCH API
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      // FROM PRODUCT DETAILS PAGE
      if (location.state?.products?.length > 0) {
        setProducts(location.state.products);
        setLoading(false);
        return;
      }

      // DIRECT OPEN → API CALL
      const data = await getcategory();
      setProducts(data || []);
      setLoading(false);
    };

    fetchData();
  }, []);


  const handleShow = (index) => {
    setCurrentIndex(index);
    setShow(true);
  };

  const handleClose = () => setShow(false);

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? products.length - 1 : prev - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev === products.length - 1 ? 0 : prev + 1
    );
  };

  // Skeleton
  const SkeletonCard = () => (
    <div className="col-md-3">
      <div className="box">
        <Skeleton height={200} />
        <div className="d-flex justify-content-between mt-2">
          <Skeleton width={60} />
          <Skeleton circle width={20} height={20} />
        </div>
      </div>
    </div>
  );

  return (
    <>
  <BreadcrumbSecand
    search={search}
    setSearch={setSearch}
  />

  <section className="Category-Graid mt-2">
    <div className="container">
       <div className="row row-cols-2 row-cols-xl-5 g-3">
     {loading ? (
  Array.from({ length: 5 }).map((_, i) => (
    <SkeletonCard key={i} />
  ))
) : filteredProducts.length > 0 ? (
  filteredProducts.map((item, index) => (
    <div className="col-md-3" key={index}>
      <div className="box">
        <div
          className="boximgaes"
          onClick={() => handleShow(index)}
        >
          <img
            src={item.image_path}
            alt={item.design}
            style={{ cursor: "pointer", width: "100%" }}
          />
        </div>

        <div className="box-title d-flex justify-content-between align-items-center mt-2">
          <p>
            {item.design} {item.shade}
          </p>

          <Link to="#" className="text-yellow">
            <i className="bi bi-heart"></i>
          </Link>
        </div>
      </div>
    </div>
  ))
) : (
  <div className="col-12 text-center">
    <h5>No products found</h5>
  </div>
)}
    </div>
  </div>
</section>

      {/* MODAL */}
      {!loading && products.length > 0 && (
        <GridListingData
          Modal={Modal}
          show={show}
          handleShow={handleShow}
          handleClose={handleClose}
          handlePrev={handlePrev}
          Button={Button}
          Product={products}
          currentIndex={currentIndex}
          handleNext={handleNext}
          ModalBoxPopup={ModalBoxPopup}
          setCurrentIndex={setCurrentIndex}
        />
      )}
    </>
  );
}

export default ProductGraid;